import { render, staticRenderFns } from "./RelatorioTable.vue?vue&type=template&id=27835010"
import script from "./RelatorioTable.vue?vue&type=script&lang=js"
export * from "./RelatorioTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports